import PNGIcon from './png.js';
import SVGIcon from './svg.js';

const MyIcons = {
  ...PNGIcon,
  ...SVGIcon,
};

export { MyIcons };
